import React, { useMemo } from 'react';

import { Grid } from '@gogame/components';

import { MarksStatisticItem } from './MarksStatisticItem';

export const MarksStatistic = ({ data = [] }) => {
  const marks = useMemo(
    () =>
      [5, 4, 3, 2, 1].map((mark) => {
        const elements = data.filter((item) => item.mark === mark);
        const count = elements.length;
        const value = (elements.length / data.length) * 100 || 0;

        return { mark: mark, value: value, count: count };
      }),
    [data]
  );

  return (
    <Grid container direction={'column'}>
      {marks.map(({ mark, value, count }) => {
        return (
          <Grid key={mark} item>
            <MarksStatisticItem mark={mark} value={value} count={count} />
          </Grid>
        );
      })}
    </Grid>
  );
};
